import ExtractContentEditor from '../../../pages/contentOptimizer/contentPage/content/optimizerTab/tiptapEditor/moreDropdown/extractContentEditor/ExtractContentEditor';

export default ExtractContentEditor;
